import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'

interface RollTextProps {
    children: string
    className?: string
}

/**
 * Text that rolls up to a fresh copy of itself on hover. The closest parent
 * needs the `group` class.
 */
export const RollText: FC<RollTextProps> = ({ children, className }): ReactNode => {
    return (
        <span className={cn('relative inline-block overflow-hidden align-top', className)}>
            <span className='block transition-transform duration-500 ease-expo group-hover:-translate-y-full'>
                {children}
            </span>

            <span
                aria-hidden='true'
                className='absolute inset-0 block translate-y-full transition-transform duration-500 ease-expo group-hover:translate-y-0'
            >
                {children}
            </span>
        </span>
    )
}
